// extracted by mini-css-extract-plugin
export default {"background":"styles_background__DGE9c","redirect":"styles_redirect__cvEgV","link_button":"styles_link_button__9xmVB","title":"styles_title__-Qnwt"};